module.exports = "<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <h1>Lorem Ipsum</h1>\n            <p>Lorem ipsum dolor sit amet ...</p>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/html-page-snippets/page.basic.html
// module id = 617
// module chunks = 0